// http://localhost:8080/api/user_logout/checkUserInfo

const env = process.env.NODE_ENV
const baseUrl = env === 'development' ? '/api/user_logout' : 'https://api.xd.com/api/user_logout'
const getFormData = (data) => {
  const formData = new FormData()
  for (const i in data) {
    formData.append(i, data[i])
  }
  return formData
}
var myHeaders = new Headers()
myHeaders.append('Cookie', 'XDEBUG_SESSION=www-data')
const API = {
  checkUserInfo (data) {
    const formData = getFormData(data)
    return fetch(`${baseUrl}/checkUserInfo`, {
      method: 'POST',
      headers: myHeaders,
      body: formData,
      redirect: 'follow'
    }).then((res) => {
      return res.json().then((data))
    })
  },
  checkReal (data) {
    const formData = getFormData(data)
    return fetch(`${baseUrl}/checkReal`, {
      method: 'POST',
      headers: myHeaders,
      body: formData,
      redirect: 'follow'
    }).then((res) => {
      return res.json().then((data))
    })
  },
  submitLogout (data) {
    const formData = getFormData(data)
    return fetch(`${baseUrl}/submitLogout`, {
      method: 'POST',
      headers: myHeaders,
      body: formData,
      redirect: 'follow'
    }).then((res) => {
      return res.json().then((data))
    })
  }
}
export default API
